const nativeHandler = {
  methods: {
    backNative(fallbackFn) {
      const {isAndroid, isWebview} = window.USER?.agent || {};

      // fallback to assigned function when user agent is not webview
      if (!isWebview) {
        fallbackFn?.();
        return;
      }

      if (isAndroid) {
        window.android?.back();
      } else {
        window.webkit?.messageHandlers?.back?.postMessage('');
      }
    },
    closeNative(fallbackFn) {
      const {isAndroid, isWebview} = window.USER?.agent || {};

      if (!isWebview) {
        fallbackFn?.();
        return;
      }

      if (isAndroid) {
        window.android?.close();
      } else {
        window.webkit?.messageHandlers?.close?.postMessage('');
      }
    },
  },
};

export default nativeHandler;
